import { useCallback, useEffect, useState } from "react"
import { debounce } from "lodash"

export const useDebouncedInput = (initialValue: string, onChange: (value: string) => void, delay = 500) => {
    const [value, setValue] = useState(initialValue)

    const debouncedOnChange = useCallback(
        debounce((newValue) => {
            onChange(newValue)
        }, delay),
        [onChange, delay],
    )

    useEffect(() => {
        debouncedOnChange(value)
        return () => {
            debouncedOnChange.cancel()
        }
    }, [value, debouncedOnChange])

    return { innerValue: value, setInnerValue: setValue }
}
